import { Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTeaser } from '@fcom/core-api';

@Component({
  selector: 'cms-horizontal-title',
  styleUrls: ['./horizontal-title.component.scss'],
  templateUrl: './horizontal-title.component.html',
  standalone: false,
})
export class HorizontalTitleComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly content = input<CmsTeaser>();
  readonly headerLevel = input(2);
}
